import QAQuestionEntity from "../../domain/entities/qa_question.entity";
import QAResponseQuestionDto from "./qa_response_question.dto";

const fromJSON = (json: any): QAQuestionEntity => {
    return {
        id: json['id']?.toString() ?? '',
        points: json['points'] ?? 0,
        description: json['description'] ?? '',
        title: json['title'] ?? '',
        categoryId: json['category_id']?.toString() ?? '',
        agentId: json['agent_id']?.toString() ?? '',
        response: json['response'] != null ? QAResponseQuestionDto.fromJSON(json.response) : undefined
    }
}

const toJSON = (entity: QAQuestionEntity): any => {
    const parsed: { id?: number, points: number, description: string, title: string, category_id: string | number, agent_id?: string | number } = {
        id: entity.id ? parseInt(entity.id) : undefined,
        points: entity.points,//
        description: entity.description,//
        title: entity.title,//
        category_id: entity.categoryId != null && entity.categoryId != "" ? parseInt(entity.categoryId.toString()): "",//
        agent_id: entity.agentId != null && entity.agentId != "" ? parseInt(entity.agentId.toString()): "",//
    }
    if (parsed.id == null) delete parsed.id;
    return parsed;
}

const QAQuestionDto = {
    fromJSON,
    toJSON,
}

export default QAQuestionDto;